// ✅ File: src/views/LeadSourceMapping/AddEditLeadSourceMapping.jsx
// import React, { useEffect, useState, useMemo } from 'react';
// import {
//   Card,
//   Row,
//   CardTitle,
//   CardBody,
//   Button,
//   FormGroup,
//   Label,
// } from 'reactstrap';
// import { useNavigate, useLocation } from 'react-router-dom';
// import VendorBranchSelector from '../../components/VendorBranchSelector';
// import { useSelector } from 'react-redux';
// import { apiService } from '../../constants/ApiService';
// import { toast } from 'react-toastify';
// import useVendorBranch from '../../utils/useVendorBranch';

// import Autocomplete from '@mui/material/Autocomplete';
// import TextField from '@mui/material/TextField';

// const AddEditLeadSourceMapping = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { user } = useSelector((state) => state.authState);

//   const { isSuperAdmin, isAdmin, hasMultiBranch } = useVendorBranch(user);

//   const [errorMessage, setErrorMessage] = useState({});

//   // ✅ Lead Source options (Multi Purpose filter=lead_source)
//   const [sourceOptions, setSourceOptions] = useState([]);

//   // ✅ Platform static dropdown
//   const PLATFORM_OPTIONS = ['Google', 'Meta'];

//   const [formData, setFormData] = useState({
//     id: 0,
//     vendor_id: 0,
//     branch_id: 0,

//     platform: '', // ✅ dropdown
//     source: '', // ✅ dropdown (autocomplete)
//     medium: '',

//     campaign_name: '',
//     adset_name: '',
//     form_name: '',

//     remark: '',
//   });

//   useEffect(() => {
//     if (location.state) {
//       setFormData((prev) => ({
//         ...prev,
//         ...location.state,
//         id: Number(location.state?.id || prev.id || 0),
//         vendor_id: Number(location.state?.vendor_id || prev.vendor_id || 0),
//         branch_id: Number(location.state?.branch_id || prev.branch_id || 0),
//         platform: location.state?.platform ?? prev.platform,
//         source: location.state?.source ?? prev.source,
//       }));
//     }
//   }, [location.state]);

//   const loadSourceOptions = async () => {
//     try {
//       const res = await apiService.get(
//         `api/Multi_Purpose_Type_Master/GetMulti_Purpose_Type_Master?filter=lead_source&orderBy=id`,
//         {
//           headers: {
//             'Content-Type': 'application/json',
//             accept: 'application/json',
//           },
//         }
//       );

//       if (res?.status === true) {
//         setSourceOptions(Array.isArray(res.data) ? res.data : []);
//       } else {
//         setSourceOptions([]);
//       }
//     } catch (e) {
//       console.log(e);
//       setSourceOptions([]);
//     }
//   };

//   useEffect(() => {
//     loadSourceOptions();
//   }, []);

//   const onChangeHandle = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const selectedSource = useMemo(() => {
//     return (
//       sourceOptions.find(
//         (x) => (x?.multi_purpose_type || '') === (formData.source || '')
//       ) || null
//     );
//   }, [sourceOptions, formData.source]);

//   const Save = async () => {
//     if (
//       isSuperAdmin &&
//       (!formData.vendor_id || Number(formData.vendor_id) <= 0)
//     ) {
//       toast.error('Please select Vendor');
//       return;
//     }

//     if (
//       (isSuperAdmin || isAdmin || hasMultiBranch) &&
//       (!formData.branch_id || Number(formData.branch_id) <= 0)
//     ) {
//       toast.error('Please select Branch');
//       return;
//     }

//     if (!formData.platform?.trim()) {
//       toast.error('Please select Platform');
//       return;
//     }

//     if (!formData.source?.trim()) {
//       toast.error('Please select Source');
//       return;
//     }

//     if (!formData.medium?.trim()) {
//       toast.error('Please enter Medium');
//       return;
//     }

//     try {
//       const payload = {
//         ...formData,
//         id: Number(formData.id || 0),
//         vendor_id: Number(formData.vendor_id || 0),
//         branch_id: Number(formData.branch_id || 0),

//         // removed fields
//         is_active: true,
//         campaign_id: null,
//         ad_id: null,
//         adset_id: null,
//         form_id: null,
//         ad_account_id: null,
//         page_id: null,
//         auto_assign_to_id: null,
//       };

//       const res = await apiService.post(
//         `api/lead-source-mapping/Save`,
//         payload
//       );

//       if (res?.success === true) {
//         toast.success(res.message || 'Saved');
//         navigate('/list-source-map');
//       } else {
//         toast.error(res?.message || 'Failed');
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error('Something went wrong');
//     }
//   };

//   return (
//     <>
//       <VendorBranchSelector
//         user={user}
//         selectionData={formData}
//         setSelectionData={setFormData}
//         accessButton={true}
//         errorMessage={errorMessage}
//       />

//       <Card className='card-box pd-20 mb-20'>
//         <CardTitle className='border-bottom p-3 d-flex justify-content-between align-items-center'>
//           <span>Lead Source Mapping Form</span>
//           <Button color='warning' onClick={() => navigate(-1)}>
//             <i className='bi bi-arrow-left' />
//           </Button>
//         </CardTitle>

//         <CardBody>
//           <Row>
//             {/* ✅ Platform static dropdown */}
//             <FormGroup className='col-sm-4'>
//               <Label>Platform</Label>
//               <select
//                 name='platform'
//                 className='custom-select'
//                 value={formData.platform || ''}
//                 onChange={onChangeHandle}
//               >
//                 <option value=''>— Select Platform —</option>
//                 {PLATFORM_OPTIONS.map((p) => (
//                   <option key={p} value={p}>
//                     {p}
//                   </option>
//                 ))}
//               </select>
//             </FormGroup>

//             {/* ✅ Source dropdown (autocomplete) */}
//             <FormGroup className='col-sm-4'>
//               <Label>Source</Label>
//               <Autocomplete
//                 size='small'
//                 autoHighlight
//                 id='source'
//                 options={sourceOptions || []}
//                 getOptionLabel={(option) => option?.multi_purpose_type || ''}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     placeholder='Select Source'
//                     fullWidth
//                   />
//                 )}
//                 value={selectedSource}
//                 onChange={(event, newValue) => {
//                   if (newValue) {
//                     onChangeHandle({
//                       target: {
//                         name: 'source',
//                         value: newValue.multi_purpose_type,
//                       },
//                     });
//                   } else {
//                     onChangeHandle({ target: { name: 'source', value: '' } });
//                   }
//                 }}
//                 sx={{ width: '100%' }}
//               />
//             </FormGroup>

//             <FormGroup className='col-sm-4'>
//               <Label>Medium</Label>
//               <input
//                 type='text'
//                 name='medium'
//                 className='form-control'
//                 value={formData.medium || ''}
//                 onChange={onChangeHandle}
//                 placeholder='cpc / lead_form / display'
//               />
//             </FormGroup>

//             <FormGroup className='col-sm-6'>
//               <Label>Campaign Name</Label>
//               <input
//                 type='text'
//                 name='campaign_name'
//                 className='form-control'
//                 value={formData.campaign_name || ''}
//                 onChange={onChangeHandle}
//               />
//             </FormGroup>

//             <FormGroup className='col-sm-6'>
//               <Label>Adset Name</Label>
//               <input
//                 type='text'
//                 name='adset_name'
//                 className='form-control'
//                 value={formData.adset_name || ''}
//                 onChange={onChangeHandle}
//               />
//             </FormGroup>

//             <FormGroup className='col-sm-12'>
//               <Label>Form Name</Label>
//               <input
//                 type='text'
//                 name='form_name'
//                 className='form-control'
//                 value={formData.form_name || ''}
//                 onChange={onChangeHandle}
//               />
//             </FormGroup>

//             <FormGroup className='col-sm-12'>
//               <Label>Remark</Label>
//               <textarea
//                 name='remark'
//                 className='form-control'
//                 value={formData.remark || ''}
//                 onChange={onChangeHandle}
//                 rows='3'
//               />
//             </FormGroup>
//           </Row>

//           <Button color='primary' className='float-end mt-3' onClick={Save}>
//             Save
//           </Button>
//         </CardBody>
//       </Card>
//     </>
//   );
// };

// export default AddEditLeadSourceMapping;
//
// ✅ File: src/views/LeadSourceMapping/AddEditLeadSourceMapping.jsx

import React, { useEffect, useState, useMemo } from 'react';
import {
  Card,
  Row,
  CardTitle,
  CardBody,
  Button,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { useSelector } from 'react-redux';
import { apiService } from '../../constants/ApiService';
import { toast } from 'react-toastify';
import useVendorBranch from '../../utils/useVendorBranch';

import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

const getPayload = (res) => {
  if (
    res &&
    typeof res === 'object' &&
    ('success' in res ||
      'status' in res ||
      'isSuccess' in res ||
      'message' in res)
  ) {
    return res;
  }

  if (
    res?.data &&
    typeof res.data === 'object' &&
    ('success' in res.data ||
      'status' in res.data ||
      'isSuccess' in res.data ||
      'message' in res.data)
  ) {
    return res.data;
  }

  return res ?? {};
};

const AddEditLeadSourceMapping = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state.authState);

  const { isSuperAdmin, isAdmin, hasMultiBranch } = useVendorBranch(user);

  const [errorMessage, setErrorMessage] = useState({});
  const [sourceOptions, setSourceOptions] = useState([]);

  const [formData, setFormData] = useState({
    id: 0,
    vendor_id: 0,
    branch_id: 0,
    platform: '',
    source: '',
    medium: '',
    campaign_name: '',
    adset_name: '',
    form_name: '',
    remark: '',
    is_active: true,
  });

  const PLATFORM_OPTIONS = ['Google', 'Meta'];

  useEffect(() => {
    if (location.state) {
      setFormData((prev) => ({
        ...prev,
        ...location.state,
        id: Number(location.state?.id || 0),
        vendor_id: Number(location.state?.vendor_id || 0),
        branch_id: Number(location.state?.branch_id || 0),
        platform: location.state?.platform || '',
        source: location.state?.source || '',
        medium: location.state?.medium || '',
        campaign_name: location.state?.campaign_name || '',
        adset_name: location.state?.adset_name || '',
        form_name: location.state?.form_name || '',
        remark: location.state?.remark || '',
        is_active: location.state?.is_active ?? true,
      }));
    }
  }, [location.state]);

  const loadSourceOptions = async () => {
    try {
      const res = await apiService.get(
        `api/Multi_Purpose_Type_Master/GetMulti_Purpose_Type_Master?filter=lead_source&orderBy=id`,
      );

      const payload = getPayload(res);

      const rows =
        payload?.data || payload?.Data || payload?.list || payload?.List || [];

      if (
        payload?.status === true ||
        payload?.success === true ||
        Array.isArray(rows)
      ) {
        setSourceOptions(Array.isArray(rows) ? rows : []);
      } else {
        setSourceOptions([]);
      }
    } catch (e) {
      console.error(e);
      setSourceOptions([]);
    }
  };

  useEffect(() => {
    loadSourceOptions();
  }, []);

  const onChangeHandle = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const selectedSource = useMemo(() => {
    return (
      sourceOptions.find(
        (x) => (x?.multi_purpose_type || '') === (formData.source || ''),
      ) || null
    );
  }, [sourceOptions, formData.source]);

  const Save = async () => {
    if (
      isSuperAdmin &&
      (!formData.vendor_id || Number(formData.vendor_id) <= 0)
    ) {
      toast.error('Please select Vendor');
      return;
    }

    if (
      (isSuperAdmin || isAdmin || hasMultiBranch) &&
      (!formData.branch_id || Number(formData.branch_id) <= 0)
    ) {
      toast.error('Please select Branch');
      return;
    }

    if (!formData.platform?.trim()) {
      toast.error('Please select Platform');
      return;
    }

    if (!formData.source?.trim()) {
      toast.error('Please select Source');
      return;
    }

    if (!formData.medium?.trim()) {
      toast.error('Please enter Medium');
      return;
    }

    try {
      const payload = {
        ...formData,
        id: Number(formData.id || 0),
        vendor_id: Number(formData.vendor_id || 0),
        branch_id: Number(formData.branch_id || 0),
        is_active: !!formData.is_active,
        campaign_id: null,
        ad_id: null,
        adset_id: null,
        form_id: null,
        ad_account_id: null,
        page_id: null,
        auto_assign_to_id: null,
      };

      const res = await apiService.post(
        `api/lead-source-mapping/Save`,
        payload,
      );

      const response = getPayload(res);

      if (
        response?.success === true ||
        response?.status === true ||
        response?.isSuccess === true
      ) {
        toast.success(response?.message || 'Saved successfully');
        navigate('/list-source-map');
      } else {
        toast.error(response?.message || 'Failed');
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    }
  };

  return (
    <>
      <VendorBranchSelector
        user={user}
        selectionData={formData}
        setSelectionData={setFormData}
        accessButton={true}
        errorMessage={errorMessage}
      />

      <Card className='card-box pd-20 mb-20'>
        <CardTitle className='border-bottom p-3 d-flex justify-content-between align-items-center'>
          <span>Lead Source Mapping Form</span>
          <Button color='warning' onClick={() => navigate(-1)}>
            <i className='bi bi-arrow-left' />
          </Button>
        </CardTitle>

        <CardBody>
          <Row>
            <FormGroup className='col-sm-4'>
              <Label>Platform</Label>
              <Input
                type='select'
                name='platform'
                className='custom-select'
                value={formData.platform || ''}
                onChange={onChangeHandle}
              >
                <option value=''>Select</option>
                {PLATFORM_OPTIONS.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </Input>
            </FormGroup>

            <FormGroup className='col-sm-4'>
              <Label>Source</Label>
              <Autocomplete
                size='small'
                autoHighlight
                id='source'
                options={sourceOptions || []}
                getOptionLabel={(option) => option?.multi_purpose_type || ''}
                value={selectedSource}
                onChange={(event, newValue) => {
                  if (newValue) {
                    onChangeHandle({
                      target: {
                        name: 'source',
                        value: newValue.multi_purpose_type,
                      },
                    });
                  } else {
                    onChangeHandle({
                      target: {
                        name: 'source',
                        value: '',
                      },
                    });
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder='Select Source'
                    fullWidth
                  />
                )}
                sx={{ width: '100%' }}
              />
            </FormGroup>

            <FormGroup className='col-sm-4'>
              <Label>Medium</Label>
              <Input
                type='text'
                name='medium'
                value={formData.medium || ''}
                onChange={onChangeHandle}
                placeholder='cpc / lead_form / display'
              />
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Campaign Name</Label>
              <Input
                type='text'
                name='campaign_name'
                value={formData.campaign_name || ''}
                onChange={onChangeHandle}
              />
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Adset Name</Label>
              <Input
                type='text'
                name='adset_name'
                value={formData.adset_name || ''}
                onChange={onChangeHandle}
              />
            </FormGroup>

            <FormGroup className='col-sm-12'>
              <Label>Form Name</Label>
              <Input
                type='text'
                name='form_name'
                value={formData.form_name || ''}
                onChange={onChangeHandle}
              />
            </FormGroup>

            <FormGroup className='col-sm-12'>
              <Label>Remark</Label>
              <Input
                type='textarea'
                name='remark'
                rows='3'
                value={formData.remark || ''}
                onChange={onChangeHandle}
              />
            </FormGroup>

            <FormGroup className='col-sm-4 mt-2'>
              <Label check>
                <Input
                  type='checkbox'
                  name='is_active'
                  checked={!!formData.is_active}
                  onChange={onChangeHandle}
                />{' '}
                Active
              </Label>
            </FormGroup>
          </Row>

          <Button color='primary' className='float-end mt-3' onClick={Save}>
            Save
          </Button>
        </CardBody>
      </Card>
    </>
  );
};

export default AddEditLeadSourceMapping;
